import React from 'react';

// SVG Flag Icons for cross-platform compatibility
export const FlagUS = ({ size = 20 }) => (
  <svg width={size} height={size * 0.7} viewBox="0 0 60 42" style={{ borderRadius: 2, display: 'inline-block', verticalAlign: 'middle' }}>
    <rect width="60" height="42" fill="#B22234"/>
    <g fill="#FFF">
      {[0, 6.46, 12.92, 19.38, 25.84, 32.3].map((y, i) => (
        <rect key={i} y={y} width="60" height="3.23"/>
      ))}
    </g>
    <rect width="24" height="22.68" fill="#3C3B6E"/>
    <g fill="#FFF">
      {[2,8,14,20].map(x => [1.5,5,8.5,12,15.5,19].map(y => (
        <circle key={`${x}-${y}`} cx={x} cy={y} r="1"/>
      )))}
      {[5,11,17].map(x => [3.25,6.75,10.25,13.75,17.25].map(y => (
        <circle key={`${x}-${y}`} cx={x} cy={y} r="1"/>
      )))}
    </g>
  </svg>
);

export const FlagUK = ({ size = 20 }) => (
  <svg width={size} height={size * 0.7} viewBox="0 0 60 42" style={{ borderRadius: 2, display: 'inline-block', verticalAlign: 'middle' }}>
    <rect width="60" height="42" fill="#012169"/>
    <path d="M0,0 L60,42 M60,0 L0,42" stroke="#FFF" strokeWidth="7"/>
    <path d="M0,0 L60,42 M60,0 L0,42" stroke="#C8102E" strokeWidth="4"/>
    <path d="M30,0 V42 M0,21 H60" stroke="#FFF" strokeWidth="10"/>
    <path d="M30,0 V42 M0,21 H60" stroke="#C8102E" strokeWidth="6"/>
  </svg>
);

export const FlagJP = ({ size = 20 }) => (
  <svg width={size} height={size * 0.7} viewBox="0 0 60 42" style={{ borderRadius: 2, display: 'inline-block', verticalAlign: 'middle', border: '1px solid #ddd' }}>
    <rect width="60" height="42" fill="#FFF"/>
    <circle cx="30" cy="21" r="12" fill="#BC002D"/>
  </svg>
);

export const FlagCA = ({ size = 20 }) => (
  <svg width={size} height={size * 0.7} viewBox="0 0 60 42" style={{ borderRadius: 2, display: 'inline-block', verticalAlign: 'middle', border: '1px solid #ddd' }}>
    <rect width="60" height="42" fill="#FFF"/>
    <rect width="15" height="42" fill="#D52B1E"/>
    <rect x="45" width="15" height="42" fill="#D52B1E"/>
    <polygon
      fill="#D52B1E"
      points="30,12 31,15.2 33.6,14.6 33,17 37.8,16.3 37,18 39.5,20.4 38,21.3 38.6,23.6 35.4,22.9 35.8,24.7 32.6,23.7 30.9,31 29.1,31 27.4,23.7 24.2,24.7 24.6,22.9 21.4,23.6 22,21.3 20.5,20.4 23,18 22.2,16.3 27,17 26.4,14.6 29,15.2"
    />
  </svg>
);

// Map market codes to flag components
export const FLAGS = {
  US: FlagUS,
  UK: FlagUK,
  JP: FlagJP,
  CA: FlagCA,
};

// Helper component that renders flag by market code
export const MarketFlag = ({ marketCode, size = 20 }) => {
  const FlagComponent = FLAGS[marketCode];
  if (!FlagComponent) return null;
  return <FlagComponent size={size} />;
};

export default { FlagUS, FlagUK, FlagJP, FlagCA, FLAGS, MarketFlag };
